const recaptchaLoader = {}
let injected = false

// Idempotente: Login.vue lo dispara diferido (6s) y RecoverModal lo dispara al abrirse
// (lo que ocurra primero). Sin esto, cada remount de Login (logout, sesión expirada,
// token inválido) re-inyectaba el <script> y redefinía window.grecaptcha/vueRecaptchaApiLoaded.
recaptchaLoader.inject = () => {
  if (injected) return
  injected = true
  const script = document.createElement('script')
  script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
  script.async = true
  script.defer = true
  document.head.appendChild(script)
}

export default recaptchaLoader
